import { tv } from 'tailwind-variants';

export const dialogPanel = tv({
  base: [
    'py-0 rounded-none scrollbar-none fixed m-0 pb-0 z-40 flex bottom-0 flex-col h-full overflow-y-auto overflow-x-hidden max-w-[calc(33%-2rem)] md:max-w-[1116px] w-auto bg-transparent left-0',
  ],
});

export const dialogPanelHeader = tv({
  base: 'flex w-full items-center justify-end md:justify-between px-4 pr-0 text-sm font-bold',
});

export const menuColumnContainer = tv({
  base: 'flex  flex-col justify-start',
});

export const menuColumn = tv({
  base: 'flex h-full md:w-[223px] lg:w-[297px] xl:w-[372px] flex-col gap-[10px] border-r border-borderColor px-4 pt-6 bg-main',
});

export const menuColumnBottomSection = tv({
  base: '-mx-4 flex h-full flex-col gap-[10px] bg-beige p-4 pt-4 mt-2',
});

export const subMenuColumnBottomSection = tv({
  base: '-mx-4 flex h-full flex-col gap-[10px] p-4 pt-6 justify-end mb-2',
});

export const menuColumnTitle = tv({
  base: 'mb-2 font-bold',
});

export const menuButton = tv({
  base: 'flex items-center justify-between border-transparent focus:outline-none hover:underline hover:cursor-pointer',
});
